import React from 'react';
import {bool, func, object, oneOfType, string} from 'prop-types';
import {Route, Switch} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import EditBreakPageContainer from 'pages/EditBreak/EditBreakPageContainer.jsx';
import ViewAllPlatformsPageContainer from 'pages/ViewAllPlatforms/ViewAllPlatformsPageContainer';
import {requestBreakAction, unmountBreak} from 'pages/EditBreak/actions.js';
import {clearSaveErrorsAction} from "resources/actions";

class BreakPagesContainer extends React.Component {
  static propTypes = {
    match: object.isRequired,
    currentBreakId: oneOfType([string, bool]),
    getBreak: func.isRequired
  }

  state = {
    fetching: false
  };

  componentWillMount() {
    this.setState({fetching: true}, () => this.props.getBreak(this.props.match.params.breakId));
  }

  componentWillUnmount() {
    this.props.clearBreak();
    this.props.clearSaveErrors();
  }

  componentWillReceiveProps(nextProps) {
    const urlBreakId = nextProps.match.params.breakId;
    const currentBreakIsStale = urlBreakId !== nextProps.currentBreakId;

    if (!this.state.fetching && currentBreakIsStale) {
      this.setState({fetching: true}, () => this.props.getBreak(urlBreakId));
    } else if (!currentBreakIsStale && this.state.fetching) {
      this.setState({fetching: false});
    }
  }

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.url}/edit`} component={EditBreakPageContainer} />
        <Route path={`${this.props.match.url}/all`} component={ViewAllPlatformsPageContainer} />
      </Switch>
    );
  }
}

const mapStateToProps = ({ editBreak }) => ({
  currentBreakId: editBreak.selectedChallengeId
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getBreak: requestBreakAction,
  clearBreak: unmountBreak,
  clearSaveErrors: clearSaveErrorsAction,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BreakPagesContainer);



// WEBPACK FOOTER //
// ./public/pages/BreakPagesContainer.jsx